
/**
 * Determines the badge color variant based on a relevance score
 * @param score The relevance score (0-10)
 * @returns A badge variant: "destructive" (red), "warning" (orange), "caution" (yellow), or "success" (green)
 */
export const getRelevanceBadgeVariant = (score: number): "destructive" | "warning" | "caution" | "success" => {
  if (score < 2.5) {
    return "destructive"; // Red for lowest scores
  } else if (score < 5) {
    return "warning"; // Orange for low-mid scores
  } else if (score < 7.5) {
    return "caution"; // Yellow for mid-high scores
  } else {
    return "success"; // Green for highest scores
  }
};
